import {Component, OnInit} from '@angular/core';
import {UserService} from '../../shared';

@Component({
    selector: 'jhi-user-club',
    templateUrl: './user-club-unsubscribe.component.html',
    styleUrls: ['./user-club-unsubscribe.component.scss'],
})
export class UserClubUnsubscribeComponent implements OnInit {

    email: string;
    joinedUserClub: boolean;
    isSuccessMessage = false;
    isUserAlreadyJoined = false;
    isErrorMessage = false;

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        this.userService.getAccount().then((account) => {
            this.email = account.email;
            this.joinedUserClub = account.userClubMember;
            this.isUserAlreadyJoined = account.userClubMember === false;
        });

    }

    unsubscribeUser() {
        this.userService.unsubscribeUserClub().then(() => {
            this.joinedUserClub = false;
            this.isSuccessMessage = true;
        }).catch(() => {
            this.isErrorMessage = true;
        });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/user-club/user-club-unsubscribe/user-club-unsubscribe.component.ts